import { render, staticRenderFns } from "./FloatingFooter.vue?vue&type=template&id=60af6759&scoped=true&"
import script from "./FloatingFooter.vue?vue&type=script&lang=ts&"
export * from "./FloatingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingFooter.vue?vue&type=style&index=0&id=60af6759&lang=scss&scoped=true&"
import style1 from "./FloatingFooter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af6759",
  null
  
)

export default component.exports